import {Component, OnInit} from '@angular/core';
import {Localiser} from '../../../services/localiser';
import {MatDialogRef} from '@angular/material/dialog';
import {ProyectoService} from '../../../services/proyecto.service';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-delete-project',
  templateUrl: './delete-project.component.html',
  styleUrls: ['./delete-project.component.css']
})
export class DeleteProjectComponent implements OnInit {

  constructor(public localiser: Localiser, public dialogRef: MatDialogRef<DeleteProjectComponent>,
              private proyectoService: ProyectoService,
              private userService: UserService) { }

  deleteItem: boolean = false;

  deleting = false;


  dataList: any;
  selectedItem: any;

  ngOnInit(): void {
    this.proyectoService.getAll().subscribe(result => {
      this.dataList = result;
    });
  }

  goBack() {
    this.deleteItem = false;
  }

  delete() {
    if(this.deleteItem === false) {
      this.deleteItem = true;
      return;
    }

    this.deleting = true;
    this.proyectoService.delete(this.selectedItem.idProyecto).subscribe(result => {
      this.dialogRef.close(true);
      // Si borramos el proyecto que tenemos actual, se lo quitamos al user y reseteamos la cookie y el proyecto actual
      if(this.proyectoService.getProyectoActual().idProyecto === this.selectedItem.idProyecto) {
        let user = this.userService.getUser();
        const index = user.proyectos.findIndex(proyecto => proyecto.idProyecto === this.selectedItem.idProyecto);
        if (index !== -1) {
          user.proyectos.splice(index, 1);
        }
        this.userService.setUser(user);
        this.userService.setProjectCookieUser();
      }

    });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
